import React from 'react';

import {
  FormControl,
  FormHelperText,
  Input,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select as MuiSelect,
} from '@material-ui/core/';
import { SelectProps as MuiSelectProps } from '@material-ui/core/Select';
import { makeStyles, Theme } from '@material-ui/core/styles';

export interface SelectProps extends MuiSelectProps {
  defaultValue?: string;
  helperText?: string;
  id: string;
  label?: string;
  menuItems?: Record<string, string>[] | null;
  isNative?: boolean;
  startIcon?: JSX.Element;
}

const useStyles = makeStyles((theme: Theme) => ({
  startIcon: {
    marginRight: theme.spacing(1),
  },
  formControl: {
    width: '100%',

    '& [class*="MuiSelect-icon"]': {
      color: theme.palette.common.black,
    },

    '& [class*="MuiSelect-nativeInput"]': {
      border: 'none',
      bottom: 'unset',
      fontSize: theme.typography.fontSize,
      marginLeft: theme.spacing(2.5),
      opacity: 1,
      // shrink: 'none',
      width: '80%',
    },
  },
}));

export const Select = (props: SelectProps): JSX.Element => {
  const {
    defaultValue = '',
    helperText = '',
    id = '',
    isNative = false,
    label = '',
    menuItems = [],
    startIcon = null,
    ...rest
  } = props;

  const classes = useStyles();

  const renderSelectOption = (id, label, isNative) => {
    if (isNative) {
      return (
        <option key={id} value={id}>
          {label}
        </option>
      );
    }

    return (
      <MenuItem key={id} value={id}>
        {label}
      </MenuItem>
    );
  };

  const startIconElement = (
    <InputAdornment position="start">{startIcon}</InputAdornment>
  );

  const hasOptions = !!Object.keys(menuItems).length;

  return (
    <FormControl className={classes.formControl}>
      {!!label && <InputLabel htmlFor={`select-${label}`}>{label}</InputLabel>}

      <MuiSelect
        disabled={!hasOptions}
        input={
          <Input
            placeholder={defaultValue}
            {...(startIcon && { startAdornment: startIconElement })}
          />
        }
        inputProps={{
          id: `select-${id}`,
        }}
        name={id}
        native={isNative}
        MenuProps={{
          anchorOrigin: {
            vertical: 32,
            horizontal: -20,
          },
          getContentAnchorEl: null,
        }}
        {...rest}
      >
        {Object.entries(menuItems).map(([id, label]) =>
          renderSelectOption(id, label, isNative),
        )}
      </MuiSelect>

      {!!helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
